import { formatNumber as kendoFormatNumber} from "@progress/kendo-angular-intl"

export const formatNumber = (value: number, format: any) => kendoFormatNumber(value, format);